

exports.__esModule = true;
exports.$miniBrowser = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _angular = require('angular');

var _logger = require('xo-beaver/dist/logger');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _postRobot = require('post-robot');

var _postRobot2 = _interopRequireDefault(_postRobot);

var _checkout = require('xo-models/src/checkout');

var _util = require('xo-return-to-merchant/dist/util');

var _integration = require('./integration');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $miniBrowser = exports.$miniBrowser = {

    flags: {},
    config: {},

    isMiniBrowser: function isMiniBrowser() {
        return window.name && window.name.indexOf('PPFrame') === 0 && _squid.$util.isPopup() || _squid.$util.param('incontext') === '1';
    },

    isFramed: function isFramed() {
        return _squid.$util.isIFrame();
    },

    openChildWindow: function openChildWindow(childFlow, targetState, dimensions, callback) {

        if (this.childWindow) {
            _logger.$logger.warn('child_window_already_open');
            return this.childWindow;
        }

        _logger.$logger.info('popup_flow_start_' + childFlow);

        // Mask the page
        _angular.$rootScope.$emit('loading');

        // Let the parent know to show an overlay
        _postRobot2['default'].sendToParent('popup_opened');

        // Determine the url based on the target page, and open the window
        var name = 'PPFrame' + _squid.$util.hash();
        var url = window.location.href.split('#')[0] + '#/' + targetState.replace(/\./g, '/');

        this.childWindow = _squid.$util.popup(name, url, {
            top: dimensions.top,
            left: dimensions.left,
            width: dimensions.width,
            height: dimensions.height,
            location: 1,
            status: 1,
            toolbar: 0,
            menubar: 0,
            resizable: 1,
            scrollbars: 1

        }, callback);

        // If we're staying in the popup, we can just hide the current page entirely, and proxy all future post messages between our parent and the new window
        if (childFlow === _integration.$FLOWS.CHECKOUT) {
            $(document.body).hide();
            _postRobot2['default'].proxy(_postRobot2['default'].parent, this.childWindow);
        }

        return this.childWindow;
    },
    closeChildWindow: function closeChildWindow(childFlow, targetState, err) {

        if (!this.childWindow) {
            return;
        }

        _postRobot2['default'].unproxy(_postRobot2['default'].parent, this.childWindow);

        _logger.$logger.info('popup_flow_complete_' + childFlow);

        // Unmask the page
        _angular.$rootScope.$emit('loaded');

        // Let the parent know to hide their overlay
        _postRobot2['default'].sendToParent('popup_closed');

        var childWindow = this.childWindow;

        delete this.childWindow;

        // Close the window if it is not already
        childWindow.close();

        if (err) {

            _logger.$logger.warn('popup_flow_error', {
                error: err.stack || err.toString()
            });

            // If we had intended to stay in the popup, message our parent to let them know things didn't work out
            if (childFlow === _integration.$FLOWS.CHECKOUT) {
                _postRobot2['default'].sendToParent('cancel');
            }

            _angular.$rootScope.$emit('loading');
        }

        // Otherwise go to the target page of the user in the popup, and reload the page to get the latest models
        else if (targetState) {
                _uiRouter.$state.go(targetState);
                window.location.reload();
            }
    },


    getPartnerIntegration: function getPartnerIntegration(token) {
        return _squid.$promise.call(function () {

            if (window.name === 'PPFrameRedirect' || _squid.$util.param('nolegacy') === '1') {
                return true;
            }

            return _checkout.$CheckoutCartModel.instance(token).retrieve().then(function (cart) {
                return Boolean(cart.partnerIntegration);
            });
        });
    },

    getNativeCheckoutIntegration: function getNativeCheckoutIntegration(token) {
        return _squid.$promise.call(function () {

            if (_squid.$util.param('native_xo') === '1') {
                return true;
            }

            return false;
        });
    },

    getDirectIntegration: function getDirectIntegration(token) {
        return _squid.$promise.call(function () {

            if (_squid.$util.param('incontext')) {
                return true;
            }

            if (this.isMiniBrowser() || this.isFramed()) {
                return true;
            }

            if (window.location.pathname.indexOf('/checkoutnow') > -1 || window.location.pathname.indexOf('/webapps/hermes') > -1) {
                return true;
            }

            return this.getPartnerIntegration(token);
        }.bind(this));
    },

    getFlags: function getFlags(token) {
        _logger.$logger.info('miniBrowser_getFlags');
        return _squid.$promise.hash({
            isMiniBrowser: this.isMiniBrowser(),
            isFramed: this.isFramed(),
            isPartnerIntegration: this.getPartnerIntegration(token),
            isDirectIntegration: this.getDirectIntegration(token),
            isNativeCheckout: this.getNativeCheckoutIntegration(token)
        }).then(function (flags) {

            // TODO: Remove these, we should not use $rootScope
            _angular.$rootScope.miniBrowser = flags.isMiniBrowser;
            _angular.$rootScope.partnerIntegration = flags.isPartnerIntegration;

            if (flags.isPartnerIntegration) {
                _integration.$integration.setFlow(_integration.$FLOWS.PARTNER);
            } else if (flags.isFramed) {
                _integration.$integration.setFlow(_integration.$FLOWS.INCONTEXT_LIGHTBOX);
            } else if (flags.isMiniBrowser) {
                _integration.$integration.setFlow(_integration.$FLOWS.INCONTEXT_POPUP);
            } else if (flags.isNativeCheckout) {
                _integration.$integration.setFlow(_integration.$FLOWS.NATIVE_CHECKOUT);
            } else {
                _integration.$integration.setFlow(_integration.$FLOWS.CHECKOUT);
            }

            return flags;
        });
    },

    init: function init(token) {
        var _this = this;

        _logger.$logger.info('miniBrowser_init');
        return _squid.$promise.sequential([function () {
            return _this.getFlags(token);
        }, function () {
            return _this.logIntegration(token);
        }, function () {
            return _this.sendPostMessage(token);
        }, function () {
            return _this.handleWindowOpenerClose();
        }, function () {
            return _this.handleLightboxToPopup();
        }, function () {
            return _this.handlePopupFromLightBox();
        }]);
    },

    logIntegration: function logIntegration(token) {
        _logger.$logger.info('miniBrowser_logIntegration');
        return this.getFlags(token).then(function (flags) {

            var match = window.name.match(/PPFrame(\w+)/);
            var guid = match && match[1];

            if (guid) {
                _logger.$logger.info('integration_guid', {
                    guid: guid
                });
            }

            _logger.$logger.info(flags.isMiniBrowser ? 'minibrowser_flow' : 'non_minibrowser_flow');
            _logger.$logger.info(flags.isFramed ? 'framed_flow' : 'non_framed_flow');
            _logger.$logger.info(flags.isDirectIntegration ? 'direct_integration_flow' : 'non_direct_integration_flow');
            _logger.$logger.info(flags.isPartnerIntegration ? 'partner_integration_flow' : 'non_partner_integration_flow');
        });
    },

    handleWindowOpenerClose: function handleWindowOpenerClose() {
        _logger.$logger.info('miniBrowser_handleWindowOpenerClose');
        if (_integration.$integration.isContext(_integration.$CONTEXT.POPUP)) {
            var interval = setInterval(function () {
                try {
                    if (!window.opener || window.opener.closed) {
                        clearInterval(interval);
                        _logger.$logger.info('window_opener_closed');
                        // TODO: close this window if opener closed?
                    }
                } catch (err) {
                    // pass
                }
            }, 50);
        }
    },
    handleLightboxToPopup: function handleLightboxToPopup() {
        var _this2 = this;

        _logger.$logger.info('miniBrowser_handleLightboxToPopup');

        // If we're allowed to collect data in this integration, we don't need this functionality
        if (_integration.$integration.getConfig('ALLOW_COLLECT_DATA')) {
            return;
        }

        // First check our integration supports falling back to a popup
        if (!_integration.$integration.getConfig('CAN_FALLBACK_TO_POPUP')) {
            throw _integration.$integration.error('Can not fallback to popup for data collection');
        }

        _angular.$rootScope.$on('$stateChangeStart', function (event, newState) {

            // If we're in a context where we can't collect sensitive data and we enter a privileged state, try falling back to a popup window

            if (newState.loginRequired) {
                var _ret = function () {
                    event.preventDefault();

                    // If we already have a child window, don't do anything.
                    if (_this2.childWindow) {
                        return {
                            v: void 0
                        };
                    }

                    // There are two fallback flows we support here:
                    //
                    // 1. COLLECT_DATA - Collect the form data in the popup and return control to the lightbox
                    // 2. CHECKOUT - Complete the entire remaining checkout flow in the popup
                    //
                    // Right now COLLECT_DATA is kinda janky, as we need to refresh the lightbox when we get back control to get the latest
                    // models. So CHECKOUT is probably going to be a smoother experience.

                    var childFlow = _integration.$integration.getConfig('RETURN_FROM_DATA_COLLECTION_POPUP') ? _integration.$FLOWS.COLLECT_DATA : _integration.$FLOWS.CHECKOUT;

                    $miniBrowser.openChildWindow(childFlow, newState.name, $miniBrowser.config.dimensions, function (err) {
                        if (_this2.childWindow) {
                            $miniBrowser.closeChildWindow(childFlow, null, err || new Error('Child window closed'));
                        }
                    });

                    // Initialize the popup and pass down the desired flow, along with other config values
                    _postRobot2['default'].once('init', {
                        window: _this2.childWindow,

                        handler: function handler(err, data) {

                            if (err) {
                                $miniBrowser.closeChildWindow(childFlow, null, err);
                            } else {
                                return {
                                    id: $miniBrowser.config.id,
                                    flow: childFlow,
                                    dimensions: $miniBrowser.config.dimensions
                                };
                            }
                        }
                    });

                    _postRobot2['default'].on('focus', {
                        proxy: false,
                        override: true,

                        handler: function handler() {
                            if ($miniBrowser.childWindow) {
                                $miniBrowser.childWindow.focus();
                            } else {
                                throw new Error('No child window to focus');
                            }
                        }
                    });

                    _postRobot2['default'].on('close', {
                        proxy: false,
                        override: true,

                        handler: function handler(err, data, callback) {

                            if (err) {
                                return callback(err);
                            }

                            if ($miniBrowser.childWindow) {
                                $miniBrowser.closeChildWindow(childFlow);
                            }

                            callback();
                        }
                    });

                    // If we're in the data-collection flow, wait for the popup to tell us it's done
                    if (childFlow === _integration.$FLOWS.COLLECT_DATA) {

                        _postRobot2['default'].once('collect_data_complete', {
                            window: _this2.childWindow,

                            handler: function handler(err, data) {

                                if (err) {
                                    $miniBrowser.closeChildWindow(childFlow, null, err);
                                } else {
                                    $miniBrowser.closeChildWindow(childFlow, data.targetPage);
                                }
                            }
                        });
                    }
                }();

                if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
            }
        });
    },
    handlePopupFromLightBox: function handlePopupFromLightBox() {

        _logger.$logger.info('miniBrowser_handlePopupFromLightBox');
        // If we're not in a collect-data flow, we can just stay in the popup
        if (!_integration.$integration.isFlow(_integration.$FLOWS.COLLECT_DATA)) {
            return;
        }

        _angular.$rootScope.$on('$stateChangeStart', function (event, newState) {

            if (!newState.loginRequired) {
                event.preventDefault();

                // Mask the page, since we're done
                _angular.$rootScope.$emit('loading');

                // Tell the parent the data collection is complete, and pass the target page for it to transition to
                _postRobot2['default'].sendToParent('collect_data_complete', {
                    targetPage: newState.name
                })['catch'](function (err) {

                    // In case of any error communicating with the parent, all we can do is close the popup
                    _logger.$logger.warn('popup_flow_error', {
                        error: err.stack || err.toString()
                    });
                    window.close();
                });
            }
        });
    },


    sendPostMessage: function sendPostMessage(token) {
        return _squid.$promise.hash({

            isPartnerIntegration: this.getPartnerIntegration(token),
            checkoutAppData: _checkout.$CheckoutAppDataModel.instance(token).retrieve()

        }).then(function (data) {

            if (!_integration.$integration.getConfig('POST_MESSAGE_PARENT')) {
                return;
            }

            _postRobot2['default'].on('focus', {
                handler: function handler() {
                    throw new Error('Can not focus self');
                }
            });

            _postRobot2['default'].on('close', {
                handler: function handler(err, _data, callback) {

                    if (err) {
                        return callback(err);
                    }

                    if (!_integration.$integration.getConfig('CAN_CLOSE_SELF')) {
                        return callback(new Error('Can not close self'));
                    }

                    callback();
                    window.close();
                }
            });

            var msg = void 0;

            try {
                msg = {
                    operation: 'init',
                    cancelUrl: data.checkoutAppData.urls.cancel_url,
                    landingUrl: window.location.href,
                    secureWindowmsg: _squid.$locale.content.scripts.secureWindowmsg
                };
            } catch (err) {
                return _logger.$logger.error('minibrowser_msg_construction_failed', {
                    error: err
                });
            }

            if (!_util.$ReturnToMerchant.postToMerchant(msg)) {
                _logger.$logger.error('minibrowser_post_failed');
            }

            return _postRobot2['default'].sendToParent('init', {

                cancelUrl: data.checkoutAppData.urls.cancel_url,
                landingUrl: window.location.href,
                secureWindowmsg: _squid.$locale.content.get('scripts.secureWindowmsg')

            }).then(function (result) {

                if (result.flow) {
                    _integration.$integration.setFlow(result.flow);
                }

                $miniBrowser.config = result;
            })['catch'](function (err) {

                _logger.$logger.info('postmessage_init_failed', {
                    error: err.stack || err.toString()
                });
            });
        });
    },

    frameBust: function frameBust(token) {
        return _squid.$promise.hash({
            isFramed: this.isFramed()
        }).then(function (flags) {

            if (flags.isFramed) {
                _logger.$logger.info('frame_bust');
                _squid.$util.redirect(window.location.href);
            }
        });
    },

    resize: function resize() {
        var wrapper = document.getElementById('outerWrapper');
        var height = wrapper ? wrapper.offsetHeight : document.body.offsetHeight;
        var width = wrapper ? wrapper.offsetWidth : document.body.offsetWidth;

        var isResizeSuccess = void 0;

        if (height && width) {
            isResizeSuccess = _util.$ReturnToMerchant.postToMerchant({
                operation: 'lightbox_resize',
                height: height,
                width: width
            });

            _logger.$logger.info('lightbox_resize', {
                height: height,
                width: width
            });

            if (!isResizeSuccess) {
                _logger.$logger.error('lightbox_resize_failed');
            }
        }
    }
};

angular.value("$miniBrowser", $miniBrowser);
_angular.$rootScope;

_logger.$logger;

_squid.$promise;

_squid.$util;

_squid.$locale;

_uiRouter.$state;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;

_util.$ReturnToMerchant;

_integration.$integration;

_integration.$FLOWS;

_integration.$CONTEXT;


/*****************
 ** WEBPACK FOOTER
 ** ./js/lib/miniBrowser.js
 ** module id = 155
 ** module chunks = 1
 **/